module.exports = __webpack_public_path__ + "assets/f12b5f09945da0c60957f64776d7626c.png";